<template>
  <div id="noon-report-detail">
    <!-- アドオンが読み込まれていない場合は何も表示しない -->
    <div v-if="!hasAddon"></div>
    <div v-else>
      <!-- メイン -->
      <div class="vx-card p-8 noon-report-detail-contents">
        <report-detail-header
          @clickEdit="showEditDialog()"
          @clickPrint="showPrintDialog()"
          @clickHistory="showHistoryDialog()"
          @clickApproval="showApprovalDialog"
        ></report-detail-header>
        <vs-divider class="m-0" />
        <report-detail-body></report-detail-body>
      </div>

      <!-- 編集ダイアログ -->
      <report-detail-edit-dialog
        ref="ReportDetailEditDialog"
      ></report-detail-edit-dialog>

      <!-- 変更履歴ダイアログ -->
      <report-detail-history-dialog
        ref="ReportDetailHistoryDialog"
        :groupedHistories="groupedHistories"
      >
      </report-detail-history-dialog>

      <!-- 承認ダイアログ -->
      <report-approval-dialog
        ref="ReportApprovalDialog"
      ></report-approval-dialog>
    </div>
  </div>
</template>

<script>
import AuthService from "@/services/authService";
import { DeviceInfoMixin, ColorMixin } from "@/mixins";

import { createNamespacedHelpers } from "vuex";

const { mapActions: mapActionsList } = createNamespacedHelpers(
  "vesselNoonReportList"
);
const {
  mapActions: mapActionsDetail,
  mapGetters: mapGettersDetail,
} = createNamespacedHelpers("vesselNoonReportDetail");

import ReportDetailHeader from "./header/ReportDetailHeader";
import ReportDetailBody from "./body/ReportDetailBody";

import ReportDetailHistoryDialog from "./dialog/history/ReportDetailHistoryDialog";
import ReportDetailEditDialog from "./dialog/edit/ReportDetailEditDialog";
import ReportApprovalDialog from "./dialog/approval/ReportApprovalDialog";

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  components: {
    ReportDetailHeader,
    ReportDetailBody,
    ReportDetailHistoryDialog,
    ReportDetailEditDialog,
    ReportApprovalDialog,
  },
  data() {
    return {
      hasAddon: false,
    };
  },
  computed: {
    ...mapGettersDetail(["groupedHistories"]),
  },
  methods: {
    ...mapActionsList(["getReportSetting"]),
    ...mapActionsDetail(["getReportDetail", "getReportItems", "resetState"]),
    showEditDialog() {
      this.$refs.ReportDetailEditDialog.show();
    },
    showHistoryDialog() {
      this.$refs.ReportDetailHistoryDialog.show();
    },
    showPrintDialog() {
      window.print();
      window.close();
    },
    showApprovalDialog(transactionId) {
      this.$refs.ReportApprovalDialog.show(transactionId);
    },
  },

  async mounted() {
    this.hasAddon = await AuthService.hasAddon(
      AuthService.ADDON_IDS.VESSEL_NOON_REPORT
    );
    if (!this.hasAddon) return;

    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";

    await this.getReportSetting();
    this.$nprogress.set(0.3);

    const payload = {
      vesselId: this.$route.params.vesselId,
      reportId: this.$route.params.reportId,
    };
    await this.getReportDetail(payload);
    this.$nprogress.set(0.5);
    await this.getReportItems();
    this.$nprogress.set(1.0);
  },

  destroyed() {
    this.resetState();
    this.$nprogress.done(true);
    this.$nprogress.remove();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

#noon-report-detail {
  --vs-primary: 3, 155, 229;
  font-family: $aisea-font-family;

  .noon-report-detail-contents {
    box-sizing: border-box;
  }
}
</style>
